import * as types from 'modules/notifications/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} State */
const initialState = false;

const open = () => true;

const close = () => false;

export default createReducer(initialState, {
  [types.OPEN_PERMISSION_MODAL]: open,
  [types.REFUSE_PERMISSION]: close,
  [types.ACCEPT_PERMISSION]: close,
});
